import { Title } from 'src/features/home/components/title/title';
import { StyledDescriptionWrapper, StyledImage, StyledImageContainer, StyledImagesContainer, StyledImageTitle } from 'src/features/home/components/description/description.styles';
import { StyledDescription } from 'src/features/home/home.styles';
import { descriptionImages } from 'src/features/home/components/description/description.constants';
export const Description = () => <StyledDescriptionWrapper data-sentry-element="StyledDescriptionWrapper" data-sentry-component="Description" data-sentry-source-file="description.tsx">
    <Title title="Real-world offensive & defensive cyber-security training" data-sentry-element="Title" data-sentry-source-file="description.tsx" />
    <StyledDescription data-sentry-element="StyledDescription" data-sentry-source-file="description.tsx">
      Access over 900 training labs and learning pathways suited to all levels, from the complete beginner to the
      seasoned hacker. TryHackMe makes learning engaging, entertaining, accessible, and affordable.
    </StyledDescription>
    <StyledImagesContainer data-sentry-element="StyledImagesContainer" data-sentry-source-file="description.tsx">
      {descriptionImages.map(({
      src,
      alt,
      title
    }) => <StyledImageContainer key={title}>
          <StyledImage src={src} alt={alt} />
          <StyledImageTitle>{title}</StyledImageTitle>
        </StyledImageContainer>)}
    </StyledImagesContainer>
  </StyledDescriptionWrapper>;